import PropTypes from 'prop-types';

export const AppointmentInformation = ({ listItem }) => (
  <>
    <p>We want to help you find products that will give you the best night’s sleep.</p>
    <ul>
      <li>
        Before your appointment we’ll send you a separate email with the meeting link and call you
        <strong> 5 minutes before </strong>
        your appointment to check you’re all set up and ready
      </li>
      <li>
        During your appointment we’ll talk about your sleep needs and recommend products that will
        suit you.
      </li>
      <li>
        If you would like to talk about mattresses and duvets, it will be useful to know what you
        currently have. Check your mattress label for information on type and firmness. Check your
        duvet label for filling and tog rating.
      </li>
    </ul>
    <br />
    <h2>Useful links</h2>
    <ul>
      <li>
        <a
          target="_blank"
          href="https://www.johnlewis.com/buying-guides/mattresses-buying-guide?intcmp=ic_20200817_mattressbg_cp_hom_a_af"
          rel="noopener noreferrer"
        >
          Mattress buying guide
        </a>
      </li>
      <li>
        <a
          target="_blank"
          href="https://www.johnlewis.com/buying-guides/60-day-mattress-trial?intcmp=ic_20210412_comforttrialbedroom_cp_hom_a_af"
          rel="noopener noreferrer"
        >
          Our 60 day comfort trial
        </a>
      </li>
      <li>
        <a
          target="_blank"
          href="https://www.johnlewis.com/buying-guides/beds-buying-guide?intcmp=ic_20200817_bedsbg_cp_hom_a_af"
          rel="noopener noreferrer"
        >
          Bed buying Guide
        </a>
      </li>
      {listItem}
    </ul>
  </>
);

AppointmentInformation.propTypes = {
  listItem: PropTypes.node.isRequired,
};

export const RemoteAppointmentInformation = ({ listItem }) => (
  <>
    <p>We want to help you find products that will give you the best night’s sleep.</p>
    <ul>
      <li>
        Before your appointment we’ll send you a separate email with the meeting link and call you
        <strong> 5 minutes before </strong>
        your appointment to check you’re all set up and ready
      </li>
      <li>
        During your appointment we’ll talk about your sleep needs and recommend products that will
        suit you.
      </li>
      <li>
        If you would like to talk about mattresses and duvets, it will be useful to know what you
        currently have. Check your mattress label for information on type and firmness. Check your
        duvet label for filling and tog rating.
      </li>
    </ul>
    <br />
    <h2>Useful links</h2>
    <ul>
      <li>
        <a
          target="_blank"
          href="https://www.johnlewis.com/buying-guides/mattresses-buying-guide?intcmp=ic_20200817_mattressbg_cp_hom_a_af"
          rel="noopener noreferrer"
        >
          Mattress buying guide
        </a>
      </li>
      <li>
        <a
          target="_blank"
          href="https://www.johnlewis.com/buying-guides/60-day-mattress-trial?intcmp=ic_20210412_comforttrialbedroom_cp_hom_a_af"
          rel="noopener noreferrer"
        >
          Our 60 day comfort trial
        </a>
      </li>
      <li>
        <a
          target="_blank"
          href="https://www.johnlewis.com/buying-guides/beds-buying-guide?intcmp=ic_20200817_bedsbg_cp_hom_a_af"
          rel="noopener noreferrer"
        >
          Bed buying Guide
        </a>
      </li>
      {listItem}
    </ul>
  </>
);

RemoteAppointmentInformation.propTypes = {
  listItem: PropTypes.node.isRequired,
};
